import * as theme from '@components/style';

// 修改变量
// theme.basicColor.dark = 'xxx';

export default theme;
